export default __webpack_public_path__ + "static/media/project2.7676d120.jpg";